import { render, staticRenderFns } from "./content.vue?vue&type=template&id=a88b1a12&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.scss?vue&type=style&index=0&id=a88b1a12&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b1a12",
  null
  
)

export default component.exports